import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0C] text-[#8A8A93]">
        <span className="overline">Loading</span>
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
